import React from "react";
// styles
import styles from "./Spinner.module.css";

export default function Spinner(props) {
  return <span className={styles.spinner} {...props}></span>;
}
